<template>
    <div id="running-page">
        <v-dialog v-model="dialog" persistent width="500">
            <v-card>
                <v-toolbar color="primary" dark flat dense cad>
                    <v-toolbar-title class="subheading">Tambah Running Text</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="text-xs-left">
                    <v-form v-model="valid" ref="form" lazy-validation>
                        <v-container>
                            <v-layout fluid wrap>
                                <v-flex lg12 sm12 xs12>
                                    <v-text-field label="Pesan" name="name" v-model="adddata.msg"></v-text-field>
                                </v-flex>

                                <v-flex lg12 sm12 xs12>
                                    <v-select
                                            label="Status"
                                            item-text="text"
                                            item-value="aktif"
                                            v-model="adddata.aktif"
                                            :items="statuses"
                                    ></v-select>
                                </v-flex>
                                <v-flex lg12 sm12 xs12 pa-20>
                                    <v-dialog
                                            ref="dialog"
                                            v-model="modaldate"
                                            :return-value.sync="adddata.expired"
                                            persistent
                                            width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field prepend-icon="event" v-on="on" v-model="adddata.expired"
                                                          label="Masa Aktif"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="adddata.expired" scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="modaldate = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.dialog.save(adddata.expired)">OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="closeform()">Cancel</v-btn>
                        <v-btn color="success" :loading="loading" @click="simpanForm(adddata)">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex lg12>
                    <v-card>
                        <v-toolbar elevation="0">
                            <v-text-field
                                    flat
                                    solo
                                    prepend-icon="search"
                                    placeholder="Type something"
                                    v-model="search"
                                    hide-details
                                    class="hidden-sm-and-down">

                            </v-text-field>
                            <v-spacer/>
                            <v-btn color="primary" class="text--white" @click.native="openmodal()">
                                <v-icon color="white"  class="text--white">add</v-icon>Add
                            </v-btn>
                            <v-btn class="ml-2" color="primary" @click.native="getdata()">
                                <v-icon dark>refresh</v-icon>Refresh
                            </v-btn>
                        </v-toolbar>
                        <v-divider></v-divider>

                        <v-card-text class="pa-0">
                            <v-data-table
                                    :headers="headers"
                                    :search="search"
                                    :items="list"
                                    item-key="id"
                                    show-select
                                    :loading="loading"
                                    v-model="selected">

                                <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
                                <template v-slot:progress>
                                    <v-skeleton-loader
                                            v-if="loading"
                                            transition="fade-transition"
                                            type="table-tbody">
                                    </v-skeleton-loader>
                                </template>
                                <template v-slot:item.expired="{ item }">
                                    <div class="ma-4">
                                        {{formattanggal(item.expired)}}
                                    </div>
                                </template>
                                <template v-slot:item.aktif="{ item }">
                                    <div class="ma-4 text-xs-left">
                                        <v-chip v-if="item.aktif===1" color="green" small text-color="white">
                                            {{ statusformat(item.aktif) }}
                                        </v-chip>
                                        <v-chip v-else color="red" small text-color="white">
                                            {{ statusformat(item.aktif) }}
                                        </v-chip>
                                    </div>
                                </template>
                                <template v-slot:item.action="{ item }">
                                    <div class="ma-4 text-xs-left">
                                        <v-btn @click.native="openFormEdit(item)" icon>
                                            <v-icon dark color="primary">edit</v-icon>
                                        </v-btn>
                                        <v-btn @click.native="deleteItem(item)" icon small>
                                            <v-icon dark color="pink">delete</v-icon>
                                        </v-btn>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

    </div>
</template>

<script>
    import moment from 'moment';
    import {mapState, mapActions} from 'vuex'
    export default {
        name: "RunningTextPage",
        data: () => ({
            search:"",
            selected: [],
            valid:false,
            state_add:false,
            modaldate: false,
            date: new Date().toISOString().substr(0, 10),
            adddata: {},
            statuses: [
                {
                    aktif: 1,
                    text: 'Enable'
                },
                {
                    aktif: 0,
                    text: 'Disable'
                }
            ],
            headers: [
                {
                    text: 'Text',
                    value: 'msg'
                },
                {
                    text: 'Status',
                    value: 'aktif'
                },
                {
                    text: 'Expired',
                    value: 'expired'
                },
                {
                    text: 'Action',
                    value: 'action'
                },
            ]
        }),
        mounted(){
          this.getdata();
        },
        computed: {
            ...mapState('RunningText', ['list', 'dialog', 'loading', 'apppopup'])
        },
        methods: {
            ...mapActions({
                logout: 'account/logout',
                addNew: 'RunningText/Add',
                EditRunningText: 'RunningText/Edit',
                closeDialog: 'RunningText/closeDialog',
                openDialogForm: 'RunningText/OpenDialogForm',
                getdata: 'RunningText/list',
                delete_text: 'RunningText/Delete'
            }),
            async openFormEdit (data) {
                this.adddata = data
                this.state_add = false
                await this.openDialogForm()
            },
            openmodal () {
                this.adddata={}
                this.state_add = true
                this.openDialogForm()
            },
            formattanggal(tgl){
                return moment(tgl).format("YYYY/MM/DD ")
            },
            statusformat (value) {
                let a = 'Disable'
                if (value === 1) {
                    a = 'Enable'
                }
                return a
            },
            async simpanForm(data) {
                if (this.state_add) {
                    await this.addNew(data)
                } else {
                    await this.EditRunningText(data)
                }
            },
            deleteItem(data) {
                this.delete_id = data.id
                this.$confirm('Yakin akan hapus ?', { color: 'red',title:'Hapus',icon:'fa-danger' }).then(res => {
                    if (res) {
                        this.delete_text(this.delete_id)
                    }
                })
            },
            closeform() {
                this.adddata={}
                this.closeDialog()
                this.state_add = false
                this.getNews()
            },
        },

    }

</script>

<style scoped>

</style>
